import React, { useEffect, useRef, useState } from "react"
import { IMAGES } from "constants/index"
import { useSelector } from "react-redux"
import { getMessageAttachment } from "services/quickblox"
import { getInitials, renderUserProfileIcon } from "./utils"
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import { ReactComponent as PeopleFill } from "../../assets/images/inbox/people-fill.svg";
import { ReactComponent as PersonCircle } from "../../assets/images/inbox/person-circle.svg";
import { useDialogManager } from "./helperHooks/HelperContext"

export default function ChatWindowDM(props) {
  const { handleLoadMore, selectedChat, chatCred, messages, inboxSession } = props
  const { setDialogIdetailsArea, getDialogProfileImage, getdUserProfile } = useDialogManager();
  const currentUser = useSelector(state => state.Login.authUser)
  const [initialLoad, setInitialLoad] = useState(true)
  const lastMessageRef = useRef(null)

  useEffect(() => {
    if (messages?.items?.length > 0 && initialLoad) {
      lastMessageRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      })
    }
  }, [messages])

  return (
    <div className="direct-messages w-100">
      <header className="inbox-right-header thumbnail-wrapper">
        <div className="board-thumbnail">
          {selectedChat?.profile ? (
            <div className="user-avatar">
              <img src={selectedChat?.profile} alt="User avatar" />
            </div>
          ) : (
            selectedChat?.name && (
              <div className="initial-character direct-messages-in ">
                <h3 className="m-0 p-0">
                  {selectedChat?.type === 2 && selectedChat?.photo && selectedChat?.photo !== "null" ? (
                    <img
                      className="bi bi-people-fill rounded-circle"
                      loading="lazy"
                      width="50"
                      height="50"
                      src={getDialogProfileImage(selectedChat?.photo)}
                      alt="Group Avatar"
                    />
                  ) : selectedChat?.type === 2 && selectedChat?.photo ? (
                    <PeopleFill height="20px" width="20px" fill="#75b35b" />
                  ) : selectedChat?.type === 3 ? (() => {
                    const matchedUser = selectedChat?.userList?.find(
                      user => user?.display_name?.trim() === selectedChat?.name?.trim()
                    );
                    const profileUrl = matchedUser?.profile_pic?.file?.url;
                    return profileUrl ? (
                      <img
                        src={profileUrl}
                        alt="User Avatar"
                        className="rounded-circle"
                        style={{ width: '25px', height: '25px' }}
                      />
                    ) : (
                      <PersonCircle style={{ width: '25px', height: '25px' }} fill="#75b35b" />
                    );
                  })() : (
                    getInitials(selectedChat?.name)
                  )}
                </h3>
              </div>
            )
          )}
        </div>

        <div className="comment-content">
          <h4 className="d-flex justify-content-between align-items-center mb-0">
            { selectedChat?.experience_name ? selectedChat?.experience_name :  selectedChat?.name ? selectedChat?.name : "---"}
            <span className="posted-user"></span>
          </h4>
          <p className="post-description">
            {selectedChat?.subTitle ? selectedChat?.subTitle : "---"}
          </p>
          {/*{selectedChat?.userList?.length > 0 ? (
            <UncontrolledDropdown group>
              <DropdownToggle data-toggle="dropdown" tag="span">
                <p className="post-description cursor-pointer">
                  {renderUserProfileIcon(selectedChat?.userList[0])}
                  {selectedChat?.userList?.length > 1 &&
                    renderUserProfileIcon(selectedChat?.userList[1])}

                  {selectedChat?.userList?.length === 1 && (
                    <span className="members-text">member</span>
                  )}
                  {selectedChat?.userList?.length === 2 && (
                    <span className="members-text">members</span>
                  )}
                  {selectedChat?.userList.length > 2 && (
                    <>
                      <span className="plus-icon">+</span>
                      <span className="member-count">
                        {selectedChat?.userList.length - 2}
                      </span>
                      <span className="members-text">
                        {selectedChat?.userList.length > 3
                          ? " members"
                          : " member"}
                      </span>
                    </>
                  )}
                </p>
              </DropdownToggle>
              <DropdownMenu>
                <ul className="dropdown-avatar-wrapper">
                  {selectedChat?.userList.map(user => (
                    <li className="d-flex align-items-center" key={user?.id}>
                      <span className="square-avatar">
                        {user?.profile_pic?.file?.url ? (
                          <img
                            src={user?.profile_pic?.file?.url}
                            alt="User Avatar"
                            width={"50"}
                            height={"50"}
                            className="message-avatar"
                          />
                        ) : (
                          <div className="initial-character video-call-in">
                            {getInitials(
                              `${user?.first_name} ${user?.last_name}`
                            )}
                          </div>
                        )}
                      </span>
                      {`${user?.first_name} ${user?.last_name}`}
                    </li>
                  ))}
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : (
            <span className="members-text">No chat participants</span>
          )} */}
        </div>
        {/* {selectedChat?.type === 2 ?
          <div className="dialog-header__body-right">
            <span className="dialog-header__icon" onClick={() => { setDialogIdetailsArea(prev => !prev) }}>
              <div className="dialog-header-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 44 44"
                  className="dialog-header-right__icon"
                >
                  <path d="M20.167 27.5h3.666v3.667h-3.666zm0-14.667h3.666v11h-3.666zm1.815-9.166C11.862 3.667 3.667 11.88 3.667 22s8.195 18.333 18.315 18.333c10.138 0 18.351-8.213 18.351-18.333S32.12 3.667 21.982 3.667m.018 33c-8.103 0-14.667-6.564-14.667-14.667S13.897 7.333 22 7.333 36.667 13.897 36.667 22 30.103 36.667 22 36.667" />
                </svg>
              </div>
            </span>
          </div> : null} */}

      </header>
      <div className="inbox-chat-body" style={{ wordBreak: "break-all" }}>
        <div className="chat-messages">
          {messages?.items?.length > 0 && messages?.showLoadMore && (
            <div
              className="text-center btn w-100"
              onClick={() => {
                setInitialLoad(false)
                handleLoadMore()
              }}
            >
              Load More Messages
            </div>
          )}
          {messages?.items?.length > 0 ? (
            messages.items.map((data, key) => {
              let prevMssgDay, date
              let crrntMssgDay = new Date(data.created_at).toLocaleDateString()
              if (key === 0) {
                date = new Date(data.created_at).toLocaleDateString()
              } else {
                prevMssgDay = new Date(
                  messages.items[key - 1].created_at
                ).toLocaleDateString()
                if (prevMssgDay !== crrntMssgDay) {
                  date = new Date(data.created_at).toLocaleDateString()
                } else {
                  date = false
                }
              }
              const loggedInUserIsSender = data.sender_id === chatCred.qb_id
              const commentSender = selectedChat?.userList?.find(
                user => user?.chat_credentials?.qb_id === data?.sender_id
              )

              const senderName =
                (commentSender?.first_name
                  ? commentSender?.first_name + " "
                  : "---") +
                (commentSender?.last_name ? commentSender.last_name : "---")

              return data?.notification_type ? (
                <React.Fragment key={key}>
                  <div className="w-100 text-center py-2">{data?.message?.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                  ))}</div>
                </React.Fragment>
              ) : (
                <React.Fragment key={key}>
                  {date && <div className="w-100 text-center py-2">{date}</div>}

                  <div
                    className={`message ${loggedInUserIsSender ? "message-sent" : "message-received"
                      }`}
                  >
                    <div className="message-content">
                      <h5 className="message-header">
                        {senderName}
                        <span className="message-time text-uppercase">
                          {new Date(data.created_at).toLocaleString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </span>
                      </h5>

                      {(() => {
                        // Helper: Render a file (image/video)
                        const renderMedia = (src, type, key = null, alt = "attachment") => {
                          if (type?.includes("image")) {
                            return (
                              <img
                                key={key}
                                src={src}
                                style={{ height: "280px", maxWidth: "100%", objectFit: "fill" }}
                                alt={alt}
                                className="gallery-img pb-2"
                              />
                            );
                          }

                          if (type?.includes("video")) {
                            return (
                              <video key={key} style={{ maxWidth: "30%" }} controls>
                                <source src={src} />
                              </video>
                            );
                          }

                          return null;
                        };

                        // Case 1: Message-based attachment
                        if (data?.message?.startsWith("[Attachment]") || data?.message?.startsWith("MediaContentEntity")) {
                          const parts = data.message.split("|");
                          const fileName = parts[1];
                          const uid = parts[2];
                          const fileType = parts[3];
                          const src = getMessageAttachment(uid, inboxSession?.token);

                          return renderMedia(src, fileType, null, fileName);
                        }

                        // Case 2: Standard attachment array
                        if (data?.attachments?.length > 0) {
                          return data.attachments.map((file, i) => {
                            const src = file?.imageUrl || getMessageAttachment(file?.id, inboxSession?.token);
                            return renderMedia(src, file?.type, i, "Attachment");
                          });
                        }

                        return null;
                      })()}
                      <p className="message-text">
                        {
                          !(data?.message?.includes("[Attachment]") || data?.message?.includes("MediaContentEntity"))
                            ? data.message
                            : <>&nbsp;</>
                        }
                      </p>

                    </div>
                    <img
                      src={getdUserProfile({ qb_id: data?.sender_id }) || IMAGES.PROFILE_PLACEHOLDER}
                      alt="User Avatar"
                      className="message-avatar"
                    />
                  </div>
                </React.Fragment>
              )
            })
          ) : (
            <div className="no-message">No Message Yet!</div>
          )}
          <div ref={lastMessageRef} />
        </div>
      </div>
    </div>
  )
}
